import { render, staticRenderFns } from "./user-calculations.vue?vue&type=template&id=4c45cf64&"
import script from "./user-calculations.vue?vue&type=script&lang=js&"
export * from "./user-calculations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports